import { render, staticRenderFns } from "./SystemSettings.vue?vue&type=template&id=74ba82f6&scoped=true"
import script from "./SystemSettings.vue?vue&type=script&lang=ts"
export * from "./SystemSettings.vue?vue&type=script&lang=ts"
import style0 from "./SystemSettings.vue?vue&type=style&index=0&id=74ba82f6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ba82f6",
  null
  
)

export default component.exports